// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1fgXr","ranges":"BmiRanges_ranges__24dpp"};